{
  "familyId": "SPR-KLANK-BAKKER",
  "questions": [
    {
      "id": "SPR-KLANK-BAKKER-001",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Iemand die bakt, is een ...",
      "options": ["bakker", "baker", "backer", "baakker"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "bakker",
            "syllables": ["bak", "ker"],
            "types": ["closed", "closed"],
            "label": "bak·ker — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank (a, e, i, o, u) in een gesloten lettergreep? Dan verdubbel je de medeklinker erachter. Zo blijft de klank kort: bak → bak-ker (niet ba-ker, want dan wordt de 'a' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_kk",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het woord 'bakker' heeft een korte 'a'. Als je de lettergrepen splitst, krijg je bak-ker. De 'k' wordt verdubbeld zodat de eerste lettergreep gesloten blijft en de 'a' kort klinkt. Schrijf je 'baker', dan lees je ba-ker met een lange 'a' — en dat is een ander woord!",
        "solutionSteps": [
          "Luister naar de klinker: de 'a' in 'bak' is kort",
          "Een korte klinker staat in een gesloten lettergreep (eindigt op een medeklinker)",
          "Verdubbel de medeklinker: bak → bak-ker",
          "Check: bak-ker — de 'a' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'a' in 'bak' zorgt ervoor dat de 'k' verdubbeld wordt: bak-ker.",
          "1": "Je dacht waarschijnlijk dat één 'k' genoeg is. Maar 'baker' lees je als ba-ker, met een lange 'a'. De dubbele 'k' houdt de lettergreep gesloten: bak-ker. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je schreef 'ck' zoals in het Engels (back, pack). Maar in het Nederlands schrijf je een dubbele 'k': bakker, niet backer. Onthoud: Nederlands gebruikt kk, niet ck.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'aa' maakt de klank juist lang. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: bak-ker."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-002",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De zwemmer traint elke dag. Welke spelling is goed?",
      "options": ["zwemer", "zweemer", "zwemmer", "zwammer"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zwemmer",
            "syllables": ["zwem", "mer"],
            "types": ["closed", "closed"],
            "label": "zwem·mer — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank? Verdubbel de medeklinker erachter. Zwem heeft een korte 'e', dus: zwem-mer (niet zwe-mer, want dan wordt de 'e' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_mm",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het woord 'zwemmer' heeft een korte 'e'. De 'm' wordt verdubbeld zodat de lettergreep gesloten blijft: zwem-mer. Schrijf je 'zwemer', dan lees je zwe-mer met een lange 'e' — en dat klinkt verkeerd.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'zwem' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zwem → zwem-mer",
          "Check: zwem-mer — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'm' genoeg is. Maar 'zwemer' lees je als zwe-mer, met een lange 'e'. De dubbele 'm' houdt de klank kort: zwem-mer. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker: zwem-mer.",
          "2": "Goed! De korte 'e' in 'zwem' zorgt voor een dubbele 'm': zwem-mer.",
          "3": "Je schreef de verkeerde klinker. Het woord komt van 'zwemmen' met een korte 'e', niet van een 'a'-klank. Luister goed: zwém-mer, niet zwám-mer. Onthoud: de klinker in de stam bepaalt de spelling."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-003",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "We gaan morgen hard ... (rennen). Welke spelling is goed?",
      "options": ["renen", "rennen", "rannen", "reenen"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "rennen",
            "syllables": ["ren", "nen"],
            "types": ["closed", "closed"],
            "label": "ren·nen — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Ook bij werkwoorden geldt de bakker-regel. 'Ren' heeft een korte 'e', dus het hele werkwoord is ren-nen. De 'n' wordt verdubbeld om de korte klank te bewaren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_nn_werkwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het werkwoord 'rennen' heeft een korte 'e'. De 'n' wordt verdubbeld: ren-nen. Zo blijft de eerste lettergreep gesloten en de 'e' kort. Schrijf je 'renen', dan lees je re-nen met een lange 'e'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'ren' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: ren → ren-nen",
          "Check: ren-nen — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'n' genoeg is. Maar 'renen' lees je als re-nen, met een lange 'e'. De dubbele 'n' houdt de klank kort: ren-nen. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Goed! De korte 'e' in 'ren' zorgt voor een dubbele 'n': ren-nen.",
          "2": "Je schreef de verkeerde klinker. Het woord komt van 'rennen' met een korte 'e', niet van een 'a'-klank. Luister goed: rén-nen, niet rán-nen. Onthoud: de klinker in de stam bepaalt de spelling.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang (renen → re-nen). Bij de bakker-regel verdubbel je de medeklinker: ren-nen."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-004",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De kat zit op de stoel. Ze is lekker aan het ... (zitten).",
      "options": ["ziten", "zutten", "zieten", "zitten"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zitten",
            "syllables": ["zit", "ten"],
            "types": ["closed", "closed"],
            "label": "zit·ten — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Zo blijft de lettergreep gesloten en de 'i' kort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_werkwoord",
      "variantIndex": 4,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Schrijf je 'ziten', dan lees je zi-ten met een lange 'i' — en dat klinkt als 'zijten'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'i' in 'zit' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zit → zit-ten",
          "Check: zit-ten — de 'i' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'ziten' lees je als zi-ten, met een lange 'i'. De dubbele 't' houdt de klank kort: zit-ten. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je schreef de verkeerde klinker. Het woord komt van 'zitten' met een korte 'i', niet van een 'u'-klank. Luister goed: zít-ten, niet zút-ten. Onthoud: de klinker in de stam bepaalt de spelling.",
          "2": "Je dacht waarschijnlijk dat de klinker verandert. Maar 'ie' is een andere klank dan 'i'. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: zit-ten.",
          "3": "Goed! De korte 'i' in 'zit' zorgt voor een dubbele 't': zit-ten."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-005",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Welk woord is goed geschreven?",
      "options": ["stofen", "stoffen", "staffen", "stoofen"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "stoffen",
            "syllables": ["stof", "fen"],
            "types": ["closed", "closed"],
            "label": "stof·fen — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel herkennen",
            "content": "Kijk naar de eerste lettergreep. Is de klinker kort? Dan moet de lettergreep gesloten zijn (eindigen op een medeklinker). Verdubbel de medeklinker om dat te bereiken: stof → stof-fen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_ff",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het woord 'stoffen' heeft een korte 'o' in de eerste lettergreep. De 'f' wordt verdubbeld: stof-fen. Schrijf je 'stofen', dan lees je sto-fen met een lange 'o' — en dat klinkt als 'stoven'. Vergelijk: stoffen (materialen) vs. stoven (langzaam koken).",
        "solutionSteps": [
          "Luister naar de klinker: de 'o' in 'stof' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: stof → stof-fen",
          "Check: stof-fen — de 'o' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'f' genoeg is. Maar 'stofen' lees je als sto-fen, met een lange 'o'. De dubbele 'f' houdt de klank kort: stof-fen. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Goed! De korte 'o' in 'stof' zorgt voor een dubbele 'f': stof-fen.",
          "2": "Je schreef de verkeerde klinker. Het woord komt van 'stof' met een korte 'o', niet van een 'a'-klank. Luister goed: stóf-fen, niet stáf-fen. Onthoud: de klinker in de stam bepaalt de spelling.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'oo' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: stof-fen."
        }
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-006",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De kok maakt soep in een grote ... (pot). Welke spelling van het meervoud is goed?",
      "options": ["poten", "patten", "potten", "pooten"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "potten",
            "syllables": ["pot", "ten"],
            "types": ["closed", "closed"],
            "label": "pot·ten — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij meervoud",
            "content": "Ook bij het meervoud geldt de bakker-regel. 'Pot' heeft een korte 'o', dus het meervoud is pot-ten. De 't' wordt verdubbeld om de korte klank te bewaren. Zonder verdubbeling wordt het 'po-ten' (lange 'o', als in 'poten' van een dier).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_meervoud",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het woord 'pot' heeft een korte 'o'. In het meervoud wordt de 't' verdubbeld: pot-ten → potten. Schrijf je 'poten', dan lees je po-ten met een lange 'o' — en dat betekent iets anders (poten van een dier). De verdubbeling houdt de klank kort.",
        "solutionSteps": [
          "Luister naar de klinker: de 'o' in 'pot' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: pot → pot-ten",
          "Check: pot-ten (korte 'o') ≠ po-ten (lange 'o', dierenpoten) ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'poten' lees je als po-ten, met een lange 'o' — dat zijn poten van een dier! Het meervoud van 'pot' is 'potten'. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je schreef de verkeerde klinker. Het woord komt van 'pot' met een korte 'o', niet van een 'a'-klank. Luister goed: pót-ten, niet pát-ten. Onthoud: de klinker in de stam bepaalt de spelling.",
          "2": "Goed! De korte 'o' in 'pot' zorgt voor een dubbele 't': pot-ten → potten.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'oo' maakt de klank lang (zoals in 'boot'). Bij de bakker-regel verdubbel je de medeklinker: pot-ten."
        }
      }
    }
  ]
}